import React, { Component } from 'react';
import PendingPage from '../../client/components/paymentPendingPage';

class PaymentPendingPage extends Component {
  render () {
    return (
      <PendingPage />
    );
  }
}

export default PaymentPendingPage;